var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPasswordHidden(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.547 12.252A9.92 9.92 0 0 0 18.44 9.81l1.75-1.75a.625.625 0 0 0-.884-.884l-1.903 1.906a7.534 7.534 0 0 0-3.9-1.056c-3.87 0-6.075 2.649-7.045 4.227a3.068 3.068 0 0 0 0 3.227 9.916 9.916 0 0 0 2.107 2.443l-1.75 1.75a.624.624 0 1 0 .884.883l 1.908-1.907a7.533 7.533 0 0 0 3.896 1.058c3.87 0 6.074-2.649 7.044-4.227a3.068 3.068 0 0 0 0-3.227zM7.523 14.824a1.824 1.824 0 0 1 0-1.917c.834-1.354 2.719-3.632 5.98-3.632a6.313 6.313 0 0 1 2.979.728l-1.259 1.258a3.12 3.12 0 0 0-4.325 4.325L9.455 17.03a8.576 8.576 0 0 1-1.932-2.206zm7.855-.959a1.875 1.875 0 0 1-1.875 1.875 1.842 1.842 0 0 1-.803-.187l2.49-2.49c.123.25.187.524.188.802zm-3.75 0a1.875 1.875 0 0 1 1.875-1.875c.278.002.553.066.803.188l-2.49 2.49a1.845 1.845 0 0 1-.188-.803zm7.854.96c-.834 1.353-2.718 3.631-5.98 3.631a6.312 6.312 0 0 1-2.978-.728l1.258-1.258a3.12 3.12 0 0 0 4.325-4.325l1.444-1.444a8.576 8.576 0 0 1 1.931 2.206 1.824 1.824 0 0 1 0 1.917z",
    fill: "#516888"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPasswordHidden);
export default __webpack_public_path__ + "static/media/passwordHidden.8a7afdc10de7bf5d515c9cfb457c237a.svg";
export { ForwardRef as ReactComponent };